<template slot="header">

  <div class="barctrl">
    <div class="barctrl-borders">
      <div class="center bold narrow_05">{{ title }}<span v-if="hasAsterisk">&nbsp;*</span></div>

      <div class="barctrl-container">
        <div class="barctrl-left" v-if="pro > 0" v-bind:style="{ width: getProWidth + '%' }"></div>
        <div class="barctrl-middle" v-if="shouldFillGap"></div>
        <div class="barctrl-right" v-if="contra > 0" v-bind:style="{ width: getContraWidth + '%' }"></div>
      </div>

      <div>
        <div class="barctrl-small narrow_05 barctrl-lefttext">
          {{ pro }}<span v-if="isPercentage">%&nbsp;</span>{{ proHeader }}
        </div>
        <div class="barctrl-small narrow_05 barctrl-righttext">
          {{ contra }}<span v-if="isPercentage">%&nbsp;</span>{{ contraHeader }}
        </div>
      </div>

      <div>&nbsp;</div>
    </div>
    <div class="barctrl-gray barctrl-line"></div>
    <div class="barctrl-line"></div>
  </div>

</template>


<script>

  export default {
    name: 'HeaderedBar',

    props:{
      'hasAsterisk': Boolean,
      'isPercentage': Boolean,
      'shouldFillGap': Boolean,
      'title': String,
      'proHeader': String,
      'contraHeader': String,
      'pro': Number,
      'contra': Number,
    },

    computed: {
      getProWidth: function() {
        if (this.pro < 1) return 0;
        if (this.isPercentage)  return this.pro - 1;
        return (100 * this.pro) / (this.pro + this.contra) - 1
      },
      getContraWidth: function() {
        if (this.contra < 1) return 0;
        if (this.isPercentage)  return this.contra - 1;
        return (100 * this.contra) / (this.pro + this.contra) - 1
      },
    }
  }

</script>
